export const CHANGENEWS = 'news/CHANGENEWS';
export const NEWLIST = 'news/NEWLIST';